import {Component, OnInit} from '@angular/core';
import {BaseParameterComponent} from '../base-parameter/base-parameter.component';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-icon-picker',
  templateUrl: './dropdown-slider-basic.component.html',
  styleUrls: [
    './dropdown-slider-basic.component.scss'
  ]
})
export class DropdownSliderBasicComponent extends BaseParameterComponent implements OnInit {
  public valueText$: Observable<string>;
  public value$: BehaviorSubject<any>;

  ngOnInit(): void {
    super.ngOnInit();

    this.value$ = new BehaviorSubject(this.getSelectedOption(this.parameterData.value));
    this.value$.subscribe(option => this.updateFn(option.value));
  }

  public getSelectedIndexOfValue() {
    return this.parameterData.options.indexOf(this.getSelectedOption(this.parameterData.value)
    );
  }

  private getSelectedOption(value) {
    return this.parameterData.options.find((option) => {
      return option.value === value;
    });
  }
}
